import useWealthlaneAdministrationApi from '../../../hooks/useWealthlaneAdministrationApi';
import useGetSchemaByIdentifier from '../../../hooks/get/useGetSchemaByIdentifier';

type UseSchemaLoaderProps = {
  identifier: string;
};

// Function to process columns and add aggregation functions
const processColumnConfig = (columns: any) => {
  return columns.map((column: any) => {
    const processedColumn = { ...column };

    if (processedColumn.aggregate) {
      switch (processedColumn.aggregate.toLowerCase()) {
        case 'sum':
          processedColumn.Aggregated = ({ value }: any) => `${value}`;
          break;
        case 'average':
          processedColumn.Aggregated = ({ value }: any) => `${value.toFixed(4)}`;
          break;
        case 'count':
          processedColumn.Aggregated = ({ value }: any) => `${value} items`;
          break;
        default:
          processedColumn.Aggregated = ({ value }: any) => `${value}`;
      }
    }

    return processedColumn;
  });
};

// Function to handle serialization and deserialization
const serializeAndDeserialize = (config: any) => {
  // Stringify the config, excluding Aggregated functions
  const stringified = JSON.stringify(JSON.parse(config), (key, value) =>
    key === 'Aggregated' ? undefined : value
  );

  // Parse the stringified config
  const parsed = JSON.parse(stringified);

  // First, process the columns to add aggregation functions
  parsed.columns = processColumnConfig(parsed.columns);

  return parsed;
};

const useTableSchemaLoader = (props: UseSchemaLoaderProps) => {
  const { identifier } = props;
  const { handleRequest } = useWealthlaneAdministrationApi();
  const { data, isLoading, status } = useGetSchemaByIdentifier(handleRequest, identifier);

  const getSchemaData = () => {
    if (isLoading) return {};
    try {
      return serializeAndDeserialize(data?.jsonSchemaContent || '{}');
    } catch (error) {
      console.error('Error parsing JSON schema content', error);
      return {};
    }
  };

  return {
    schemaData: getSchemaData(),
    isTableSchemaLoading: isLoading,
    status,
  };
};

export default useTableSchemaLoader;
